import script from "./SelectsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectsView.vue?vue&type=script&setup=true&lang=js"

import "./SelectsView.vue?vue&type=style&index=0&id=5bc9cc44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc9cc44"]])

export default __exports__